export default "__VITE_ASSET__Ca6J$H4S__"